export default __webpack_public_path__ + "static/media/1.9e5c5bcc.jpg";